export function routes($stateProvider) {
  $stateProvider
    .state('app.orientacao', {
      url: '/orientacao',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.orientacao.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Orientações',
      template: require('./directory/directory.view.html'),
      controller: 'OrientacaoListController',
      controllerAs: 'vm',
      role: 'orientacaoRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "desc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.orientacao.details', {
      url: '/{id}',
      title: 'Orientação',
      controller: 'OrientacaoDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'orientacaoRead'
    })
    .state('app.orientacao.new', {
      url: '/nova',
      title: 'Adicionar Orientação',
      template: require('./new/new.view.html'),
      controller: 'OrientacaoCreateOrientacaoController',
      controllerAs: 'vm',
      role: 'orientacaoCreate'
    })
    .state('app.orientacao.new.1', {
      template: require('./new/orientacao.1.form.html')
    })
    .state('app.orientacao.new.2', {
      template: require('./new/orientacao.2.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
